module.exports = __webpack_public_path__ + "static/media/facebook-share.a6091da5.svg";